// extracted by mini-css-extract-plugin
export default {"image":"WZ-z","loaded":"XZ-z"};